var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"licenza"},[_c('h1',[_vm._v("La licenza è scaduta, collegati al sito per rinnovarla ...")]),_c('img',{attrs:{"src":(_vm.publicPath + "img/intro/ubisell-logo.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }